import { Outlet } from 'react-router-dom';
import JobsSidebar from './JobsSidebar';

export default function JobsLayout() {
  return (
    <div className="flex h-full bg-gray-50 dark:bg-gray-900">
      <JobsSidebar />
      <div className="flex-1 overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}
